import React, { useState } from "react";
import axios from "axios";
import {
  Card,
  Input,
  Button,
  Select,
  Typography,
  Spin,
  Row,
  Col,
  Divider,
  Tag,
  message,
} from "antd";
import {
  SearchOutlined,
  EnvironmentOutlined,
  ToolOutlined,
} from "@ant-design/icons";
import Header from "components/Headers/Header";
import { Container } from "reactstrap";
import ProtectedRoute from "./Protected";

const { Title, Text } = Typography;
const { Option } = Select;

const ConsultaTaller = () => {
  const [tipo, setTipo] = useState("tanqueo");
  const [chip, setChip] = useState("");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const consultar = async () => {
    if (!chip) {
      message.warning("Ingrese el código del chip");
      return;
    }
    setLoading(true);
    setData(null);

    try {
      let url = "";
      if (tipo === "tanqueo") {
        url = `https://inspecciongnvback.azurewebsites.net/api/v1/ObtenerTallerPorChipTanqueo/${chip}`;
      } else {
        url = `https://inspecciongnvback.azurewebsites.net/api/v1/ObtenerTallerPorChip/${chip}`;
      }

      const res = await axios.get(url);
      setData(res.data);
    } catch (err) {
      message.error("No se encontró información para este chip");
    } finally {
      setLoading(false);
    }
  };

  return (
    <ProtectedRoute>
      <Header />
      <Container className="mt--7" fluid>
        <Row justify="center" style={{ marginTop: 30, padding: 15 }}>
          <Col xs={4} sm={20} md={6} lg={16}>
            <Card
              style={{
                borderRadius: 20,
                boxShadow: "0px 4px 15px rgba(0,0,0,0.1)",
              }}
            >
              <Title
                level={3}
                style={{ textAlign: "center", marginBottom: 20 }}
              >
                🔍 Consulta de Taller por Chip
              </Title>

              <Row gutter={[10, 10]} justify="center">
                <Col xs={24} sm={10}>
                  <Select
                    value={tipo}
                    onChange={(val) => setTipo(val)}
                    style={{ width: "100%" }}
                  >
                    <Option value="tanqueo">Chip de Tanqueo</Option>
                    <Option value="validador">Chip Validador</Option>
                  </Select>
                </Col>
                <Col xs={24} sm={10}>
                  <Input
                    placeholder="Ingrese el código del chip"
                    value={chip}
                    onChange={(e) => setChip(e.target.value)}
                  />
                </Col>
                <Col xs={24} sm={4}>
                  <Button
                    type="primary"
                    icon={<SearchOutlined />}
                    onClick={consultar}
                    block
                  >
                    Consultar
                  </Button>
                </Col>
              </Row>

              <Divider />

              {loading ? (
                <div style={{ textAlign: "center", padding: 20 }}>
                  <Spin tip="Consultando taller..." />
                </div>
              ) : data ? (
                <Card
                  style={{
                    marginTop: 10,
                    borderRadius: 15,
                    background: "#f9f9f9",
                    boxShadow: "0px 3px 10px rgba(0,0,0,0.1)",
                  }}
                >
                  <Title
                    level={4}
                    style={{ marginBottom: 15, textAlign: "center" }}
                  >
                    <EnvironmentOutlined /> {data.nombreTaller}
                  </Title>

                  <Row gutter={[16, 16]}>
                    <Col xs={24} md={12}>
                      <Text strong>NIT: </Text> <Text>{data.nit}</Text> <br />
                      <Text strong>Sucursal: </Text>{" "}
                      <Text>{data.sucursal}</Text> <br />
                      <Text strong>Dirección: </Text>{" "}
                      <Text>{data.direccion}</Text> <br />
                      <Text strong>Teléfono: </Text>{" "}
                      <Text>{data.telefono}</Text> <br />
                      <Text strong>Estado: </Text>{" "}
                      <Tag color={data.estado === "Activo" ? "green" : "red"}>
                        {data.estado}
                      </Tag>
                    </Col>

                    <Col xs={24} md={12}>
                      <Text strong>Certificado: </Text>{" "}
                      <Tag color="blue">{data.numeroCertificado}</Tag> <br />
                      <Text strong>Fecha emisión: </Text>{" "}
                      <Text>
                        {new Date(data.fechaEmision).toLocaleDateString()}
                      </Text>{" "}
                      <br />
                      <Text strong>Fecha vencimiento: </Text>{" "}
                      <Text>
                        {new Date(data.fechaVencimiento).toLocaleDateString()}
                      </Text>{" "}
                      <br />
                      <Text strong>Número de técnicos: </Text>{" "}
                      <Text>{data.numeroTecnicos}</Text>
                    </Col>
                  </Row>

                  <Divider />

                  <Row gutter={[16, 16]}>
                    <Col xs={24} md={12}>
                      <Title level={5}>Chips</Title>
                      <Text strong>Chip Tanqueo: </Text>{" "}
                      <Text>{data.chipTanqueo}</Text> <br />
                      <Text strong>Chip Validador: </Text>{" "}
                      <Text>{data.idRomChipValidador}</Text>
                    </Col>

                    <Col xs={24} md={12}>
                      <Title level={5}>Pólizas</Title>
                      <Text strong>Resp. Civil: </Text>{" "}
                      <Text>{data.polizaResponsableCivil}</Text> <br />
                      <Text strong>Legales: </Text>{" "}
                      <Text>{data.polizaLegales}</Text> <br />
                      <Text strong>Vence legales: </Text>{" "}
                      <Text>
                        {new Date(data.fechaVenceLegales).toLocaleDateString()}
                      </Text>
                      <br />
                      <Text strong>Última vigencia: </Text>{" "}
                      <Text>
                        {new Date(
                          data.ultimaVigenciaPoliticaDL,
                        ).toLocaleDateString()}
                      </Text>
                    </Col>
                  </Row>
                </Card>
              ) : (
                <Text
                  type="secondary"
                  style={{
                    display: "block",
                    textAlign: "center",
                    marginTop: 10,
                  }}
                >
                  Ingrese el chip y seleccione una opción para consultar
                </Text>
              )}
            </Card>
          </Col>
        </Row>
      </Container>
    </ProtectedRoute>
  );
};

export default ConsultaTaller;
